import { render, staticRenderFns } from "./EnableMessaging.vue?vue&type=template&id=4e01a1d7&"
import script from "./EnableMessaging.vue?vue&type=script&lang=js&"
export * from "./EnableMessaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports